import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import IconAndText from 'components/common/IconAndText'
import DazzedHeadingForGrid from 'components/common/text/DazzedHeadingForGrid'
import { useTranslation } from 'react-i18next'
import LegendIcon from 'components/CopilotControl/icons/LegendIcon'

const useStyles = makeStyles(() => ({
  legendItem: {
    margin: 5,
    marginTop: 10
  }
}))

const ScoresLegend = ({ scoreOptions }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Grid container>
      {Object.entries(scoreOptions).map(([optionKey, optionData], index) => (
        <Grid item key={index}>
          <IconAndText
            icon={<LegendIcon color={optionData.strokeColor} />}
            text={
              <DazzedHeadingForGrid
                bold
                xs={10}
                sm={10}
                md={10}
                lg={12}
                xl={12}
                style={{ color: '#727B8C', padding: '0px 7px' }}
              >
                {t(`pages.copilotControl.widgets.patientsSentiment.${optionKey}Label`)}
              </DazzedHeadingForGrid>
            }
            className={classes.legendItem}
          />
        </Grid>
      ))}
    </Grid>
  )
}

export default ScoresLegend
